import TaskBoardsAPI from 'dashboard/api/taskBoards';
import TasksAPI from 'dashboard/api/tasks';

export const actions = {
  fetchBoards: async ({ commit }) => {
    const { data } = await TaskBoardsAPI.get();
    commit('SET_TASK_BOARDS', data);
  },
  createBoard: async ({ commit }, payload) => {
    const { data } = await TaskBoardsAPI.create({ task_board: payload });
    commit('ADD_TASK_BOARD', data);
    return data;
  },
  updateBoard: async ({ commit }, { id, ...payload }) => {
    const { data } = await TaskBoardsAPI.update(id, { task_board: payload });
    commit('UPDATE_TASK_BOARD', data);
    return data;
  },
  deleteBoard: async ({ commit }, id) => {
    await TaskBoardsAPI.delete(id);
    commit('REMOVE_TASK_BOARD', id);
  },
  fetchTasks: async ({ commit }, boardId) => {
    const { data } = await TasksAPI.getByBoard(boardId);
    commit('SET_TASKS', data);
  },
  createTask: async ({ commit }, payload) => {
    const { data } = await TasksAPI.create({ task: payload });
    commit('ADD_TASK', data);
    return data;
  },
  updateTask: async ({ commit }, { id, ...payload }) => {
    const { data } = await TasksAPI.update(id, { task: payload });
    commit('UPDATE_TASK', data);
    return data;
  },
  deleteTask: async ({ commit }, id) => {
    await TasksAPI.delete(id);
    commit('REMOVE_TASK', id);
  },
  reorder: async (_ctx, positions) => {
    await TasksAPI.reorder(positions);
  },
  addAttachment: async ({ commit }, { id, files }) => {
    const { data } = await TasksAPI.addAttachment(id, files);
    commit('UPDATE_TASK', data);
    return data;
  },
  removeAttachment: async ({ commit }, { id, attachmentId }) => {
    const { data } = await TasksAPI.removeAttachment(id, attachmentId);
    commit('UPDATE_TASK', data);
    return data;
  },
  addMember: async ({ commit }, { id, userId }) => {
    const { data } = await TasksAPI.addMember(id, userId);
    commit('UPDATE_TASK', data);
    return data;
  },
  removeMember: async ({ commit }, { id, userId }) => {
    const { data } = await TasksAPI.removeMember(id, userId);
    commit('UPDATE_TASK', data);
    return data;
  },
  setWatching: async ({ commit }, { id, watching }) => {
    const { data } = watching
      ? await TasksAPI.watch(id)
      : await TasksAPI.unwatch(id);
    commit('UPDATE_TASK', data);
    return data;
  },
};
